/**
 * 全局常量配置
 * 对标 tv-linux 项目的 util/const.js
 */

/**
 * 平台类型枚举
 */
export enum Platform {
  WETV = 'wetv',
  IFLIX = 'iflix',
  TVDTV = 'tvdtv',
}

/**
 * 渠道类型枚举
 */
export enum ChannelType {
  LG = 'lg',
  Samsung = 'samsung',
  Hisense = 'hisense',
  Astro = 'astro',
  Coolita = 'coolita',
  Foxxum = 'foxxum',
  FoxxumAsia = 'foxxumasia',
  Zeasn = 'zeasn',
  TiVO = 'tivo',
  Titan = 'titan',
  NetrangeCarply = 'netrangecarply',
  KTC = 'ktc',
  SDMC = 'sdmc',
  Metax = 'metax',
  Netrange = 'netrange',
  Vewd = 'vewd',
  Default = 'default',
}

/**
 * 产品类型枚举
 */
export enum ProdType {
  Wetv = 'wetv',
  Iflix = 'iflix',
  TencentVideo = 'tencentvideo',
}

/**
 * OneLink 下载链接配置
 * 对标 tv-linux 的 ONELINK_URL
 */
export const ONELINK_URL = {
  iflix: 'https://iflix.onelink.me/IFpb?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=iflix://iflix.com/login',
  wetv: 'https://qqlivei18n.onelink.me/ETTr?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=tenvideoi18n://wetv/login',
  tvdtv:
    'https://qqlivei18n.onelink.me/nyiU/igxqfpyw?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=tenvideoi18n://wetv/login',
} as const;

/**
 * 平台名称映射
 */
export const PLATFORM_NAMES = {
  iflix: 'iflix',
  wetv: 'WeTV',
  tvdtv: 'Tencent Video',
} as const;

/**
 * App ID 配置
 */
export const APP_IDS = {
  wetv: '1200012',
  iflix: '1200016',
} as const;

/**
 * 认证 App ID 配置（用于二维码登录）
 */
export const AUTH_APP_IDS = {
  wetv: '10002',
  iflix: '10003',
} as const;

/**
 * WeTV 渠道配置
 */
export const wetvChannel = {
  '16566': {
    channelType: ChannelType.LG,
    prodType: ProdType.Wetv,
  },
  '16600': {
    channelType: ChannelType.Samsung,
    prodType: ProdType.Wetv,
  },
  '16563': {
    channelType: ChannelType.Hisense,
    prodType: ProdType.Wetv,
  },
  '16614': {
    channelType: ChannelType.Astro,
    prodType: ProdType.Wetv,
  },
  '16602': {
    channelType: ChannelType.Foxxum,
    prodType: ProdType.Wetv,
  },
  '16622': {
    channelType: ChannelType.Foxxum,
    prodType: ProdType.Wetv,
  },
  '16603': {
    channelType: ChannelType.Coolita,
    prodType: ProdType.Wetv,
  },
  '16610': {
    channelType: ChannelType.Zeasn,
    prodType: ProdType.Wetv,
  },
  '16638': {
    channelType: ChannelType.TiVO,
    prodType: ProdType.Wetv,
  },
  '16637': {
    channelType: ChannelType.Titan,
    prodType: ProdType.Wetv,
  },
  '16620': {
    channelType: ChannelType.NetrangeCarply,
    prodType: ProdType.Wetv,
  },
  '16617': {
    channelType: ChannelType.KTC,
    prodType: ProdType.Wetv,
  },
  '16611': {
    channelType: ChannelType.SDMC,
    prodType: ProdType.Wetv,
  },
  '16609': {
    channelType: ChannelType.Metax,
    prodType: ProdType.Wetv,
  },
  '16601': {
    channelType: ChannelType.Netrange,
    prodType: ProdType.Wetv,
  },
  '16572': {
    channelType: ChannelType.Vewd,
    prodType: ProdType.Wetv,
  },
};

/**
 * iflix 渠道配置
 */
export const iflixChannel = {
  '16567': {
    channelType: ChannelType.LG,
    prodType: ProdType.Iflix,
  },
  '16599': {
    channelType: ChannelType.Samsung,
    prodType: ProdType.Iflix,
  },
  '16562': {
    channelType: ChannelType.Hisense,
    prodType: ProdType.Iflix,
  },
};

/**
 * 腾讯视频渠道配置
 */
export const tencentVideoChannel = {
  '16639': {
    channelType: ChannelType.TiVO,
    prodType: ProdType.TencentVideo,
  },
  '16630': {
    channelType: ChannelType.Samsung,
    prodType: ProdType.TencentVideo,
  },
  // 目前知道的应该 只有LG用了新的这个channelId，其他应该是根据域名判断的
  '16629': {
    channelType: ChannelType.LG,
    prodType: ProdType.TencentVideo,
  },
};

/**
 * 渠道ID到渠道类型映射
 * 三星目前 tencentVideo 与 wetv使用的渠道号是同一个，使用渠道号判断可能不准，后续可能需要添加域名判断
 */
export const vChannelIdToChannelType = {
  ...wetvChannel,
  ...iflixChannel,
  ...tencentVideoChannel,
};

/**
 * localStorage 存储 key 配置
 */
export const localStorageKey = {
  paySessionIdKey: 'wetv_linux_pay_session_id', // 用于记录会员支付整个跳转拉起流程，具体详情可查看paySessionId.ts文件
  linux_tv_history_user_login: 'linux_tv_history_user_login', // 用于记录tv端 用户登录后的历史记录信息
  linux_tv_history_user_no_login: 'linux_tv_history_user_no_login', // 用于记录tv端 用户非登录时的历史记录信息
  wetv_item_action_source: 'wetv_item_action_source', // 播放页面 播放剧集来源入口，用于播放器侧上报
};

/**
 * cookie 存储 key 配置
 */
export const cookieStorageKey = {
  QIMEI: 'qimei',
  H38: 'h38',
  GUID: 'guid',
};

/**
 * 渠道账号检查参数配置
 */
export const checkChannelAccountParams = {
  bizId: 1, // 业务集，1为wetv，2为iflix，目前只放开了1；
  channelId: '16614', // 渠道id，传tv端的chid，目前仅放开了16614渠道
  userType: 3, // 账号类型，与登录场景中的账号类型定义一致，这个渠道可以传3
};

export const vplatformInfo = {
  wetv: '8',
  iflix: '8',
  tvdtv: '8',
};

export const videoAppidInfo = {
  wetv: '1200012',
  iflix: '1200016',
  tvdtv: '1200012',
};

export const PTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const TVKPlatformInfo = {
  wetv: '3580601',
  iflix: '3610601',
  tvdtv: '8040601',
};

export const ORIPTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const licenceInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const prodLineKeyToPlayPlatformKey = {
  wetv: 'tv',
  iflix: 'tv',
  tvdtv: 'tv_dtv',
};

/**
 * 清晰度相关常量
 * 内部格式（如 'fhd', 'shd'）到显示格式（如 '1080P', '720P'）的映射
 */
export const INTERNAL_TO_DISPLAY_QUALITY_MAP: Record<string, string> = {
  uhd: '4K',
  fhd: '1080P',
  shd: '720P',
  hd: '480P',
  sd: '360P',
  ld: '144P',
  hdr10: '1080P', // 臻彩1080
  dolby: '1080P', // 杜比
  suhd: '4K', // 臻彩MAX
} as const;

/**
 * 将内部格式转换为显示格式
 * @param internalQuality 内部格式（如 'hd'）
 * @returns 显示格式（如 '480P'），如果未找到则返回 null
 */
export function internalToDisplayQuality(internalQuality: string): string | null {
  if (!internalQuality) return null;
  return INTERNAL_TO_DISPLAY_QUALITY_MAP[internalQuality.toLowerCase()] || null;
}

/**
 * 获取清晰度的权重（用于排序）
 * @param quality 清晰度（内部格式或显示格式）
 * @param definitionName 可选的定义名称（内部格式，优先级更高）
 * @returns 权重值（数值越大，清晰度越高）
 */
export function getQualityWeight(quality: string, definitionName?: string): number {
  // 内部格式到权重的映射
  const qualityWeightMap: Record<string, number> = {
    uhd: 2160,
    suhd: 2160,
    fhd: 1080,
    hdr10: 1080,
    dolby: 1080,
    shd: 720,
    hd: 480,
    sd: 360,
    ld: 144,
  };

  // 首先尝试通过 definition name 映射
  if (definitionName) {
    const weight = qualityWeightMap[definitionName.toLowerCase()];
    if (weight) return weight;
  }

  // 特殊清晰度（4K/8K）
  const normalized = quality.toUpperCase();
  if (normalized.includes('4K') || normalized.includes('2160')) return 4000;
  if (normalized.includes('8K') || normalized.includes('4320')) return 8000;

  // 提取数字（如 '1080P' -> 1080）
  const match = normalized.match(/(\d+)/);
  if (match) return parseInt(match[1], 10);

  return 0;
}
